const useBulkDiscounts = (
  isOnSale: boolean,
  hasBulkDiscountData: boolean
): boolean => !isOnSale && hasBulkDiscountData;

export type BulkDiscount = {
  quantity: number;
  discount_percentage: number;
  price_before?: number;
  price_unit?: number;
};

const getBulkDiscounts = (
  bulkDiscountMetafield: string,
  regularPrice: number
) => {
  if (!bulkDiscountMetafield) return null;

  return JSON.parse(bulkDiscountMetafield).map((b: BulkDiscount) => {
    // calculate the discounted price
    const discountAmount = (regularPrice * b.discount_percentage) / 100;

    // TODO: Avoid mutating this, there must be a better way...
    return {
      ...b,
      price_before: regularPrice,
      price_unit: regularPrice - discountAmount
    };
  });
};

const getSelectedBulkDiscount = (
  bulkDiscounts: BulkDiscount[],
  target: number
) => {
  return bulkDiscounts.find((item, idx, items) => {
    const next = items[idx + 1];
    return target >= item.quantity && (!next || target < next.quantity);
  });
};

const getDefaultBulkDiscount = (regularPrice: number): BulkDiscount => ({
  quantity: 1,
  discount_percentage: 0,
  price_unit: regularPrice
});

const getBulkDiscountedUnitPrice = (
  bulkDiscounts: BulkDiscount[],
  target: number,
  initialUnitPrice: number
) => {
  const closestQuantityItem = getClosestBulkDiscount(
    bulkDiscounts,
    target,
    initialUnitPrice
  );

  return closestQuantityItem.price_unit;
};

const getHighestBulkDiscount = (bulkDiscounts: BulkDiscount[] = []) => {
  if (bulkDiscounts.length === 0) return null;

  return bulkDiscounts.reduce((prev, next) =>
    prev.discount_percentage > next.discount_percentage ? prev : next
  );
};
const getClosestBulkDiscount = (
  bulkDiscounts: BulkDiscount[],
  target: number,
  initialUnitPrice: number
) => {
  const selectedBulkDiscount = getSelectedBulkDiscount(bulkDiscounts, target);
  return selectedBulkDiscount ?? getDefaultBulkDiscount(initialUnitPrice);
};

export {
  getBulkDiscountedUnitPrice,
  getBulkDiscounts,
  getClosestBulkDiscount,
  getDefaultBulkDiscount,
  getHighestBulkDiscount,
  getSelectedBulkDiscount,
  useBulkDiscounts
};
